import { useEffect, useMemo, useRef, useState } from 'react';
import './index.scss';
import { LangText } from './LangText';
import { getCatalogTitleList } from './utils';

const getScrollOffset = () => {
    let totalHeight = 12;

    const header = document.querySelector('.ecoflow-frame-header');
    if (header) {
        totalHeight += header.getBoundingClientRect().height;
    }

    return totalHeight;
};

const getCatalogElement = (hashId: string) => {
    const elementId = hashId.startsWith('#') ? hashId.slice(1) : hashId;
    return document.getElementById(elementId);
};

export default function BlogDetailsCatalog({ tempData = {}, locale = 'us' }: { tempData: any; locale: string }) {
    const theTemp = tempData?.theTemp || [];
    const theData = tempData?.theData || {};
    const itemsA = useMemo(() => getCatalogTitleList(theTemp, theData), [theTemp, theData]);
    const TextA = LangText[locale] || LangText['us'];
    // 切换
    const [isOpen, setIsOpen] = useState(false);
    const [activeItemId, setActiveItemId] = useState<string>('');
    const catalogRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const updateStickyOffset = () => {
            if (catalogRef.current) {
                catalogRef.current.style.setProperty('--blog-delta-sticky-top-offset', `${getScrollOffset()}px`);
            }
        };

        updateStickyOffset();

        window.addEventListener('resize', updateStickyOffset);
        return () => window.removeEventListener('resize', updateStickyOffset);
    }, []);

    // 根据滚动位置高亮目录项，并同步 hash 锚点变化
    useEffect(() => {
        if (!itemsA.length) {
            return;
        }

        const hashTimers: number[] = [];

        const updateActiveByScroll = () => {
            const offset = getScrollOffset();
            let activeId = '';

            for (const item of itemsA) {
                const el = getCatalogElement(item.id);
                if (el && el.getBoundingClientRect().top <= offset + 10) {
                    activeId = item.id;
                }
            }

            setActiveItemId(activeId);
        };

        const onHashChange = () => {
            const hash = window.location.hash;
            if (hash) {
                setActiveItemId(hash);
                hashTimers.push(window.setTimeout(updateActiveByScroll, 100));
                hashTimers.push(window.setTimeout(updateActiveByScroll, 500));
                return;
            }
            updateActiveByScroll();
        };

        let ticking = false;
        const onScroll = () => {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(() => {
                    updateActiveByScroll();
                    ticking = false;
                });
            }
        };

        const initTimer = window.setTimeout(() => {
            if (window.location.hash) {
                setActiveItemId(window.location.hash);
            }
            updateActiveByScroll();
        }, 300);

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', updateActiveByScroll);
        window.addEventListener('hashchange', onHashChange);

        return () => {
            window.clearTimeout(initTimer);
            hashTimers.forEach((timer) => window.clearTimeout(timer));
            window.removeEventListener('scroll', onScroll);
            window.removeEventListener('resize', updateActiveByScroll);
            window.removeEventListener('hashchange', onHashChange);
        };
    }, [itemsA]);
    const toggleHandle = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div ref={catalogRef} className={`blog-delta-catalog blog-delta-catalog-${isOpen ? 'y' : 'n'}`}>
            <div className="delta-catalog-box">
                <div className="delta-catalog-box-h" onClick={toggleHandle}>
                    {TextA.TableOfContents}
                </div>
                <ul className="delta-catalog-box-c">
                    {itemsA.map((item: any, index: number) => {
                        return (
                            <li key={index} className={`delta-catalog-box-item ${item.id === activeItemId ? 'active' : ''}`}>
                                <a href={item.id}>{item.title}</a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
}
